module.exports = __webpack_public_path__ + "img/D201510_2.c748d2de.jpg";